import { useCityStorage } from '~/composables/useCityStorage'
import { isBot } from '~/utils/isBot'

import {
  buildGeoCatalogCityHref,
  buildVisitSectionHref,
  canAutoRedirectGeoCatalog,
  canAutoRedirectToVisitSection,
  isGeoCatalogRootPath,
} from '~/utils/geoCatalog'

export default defineNuxtRouteMiddleware((to) => {
  if (useShopHost().isShopHost.value) {
    return
  }

  const { getStoredCity } = useCityStorage()

  const ua = import.meta.server
    ? useRequestHeaders()['user-agent']
    : navigator.userAgent
  if (isBot(ua)) {
    return
  }

  const storedCity = import.meta.client ? getStoredCity() : null
  if (!storedCity) {
    return
  }

  if (canAutoRedirectToVisitSection(to.path, to.query)) {
    return navigateTo(buildVisitSectionHref(storedCity, to.query), { external: true })
  }

  if (!canAutoRedirectGeoCatalog(to.path, to.query)) {
    return
  }

  if (!isGeoCatalogRootPath(to.path)) {
    return
  }

  const pathWithSlash = to.path.endsWith('/') ? to.path : `${to.path}/`

  return navigateTo(buildGeoCatalogCityHref(pathWithSlash, storedCity, to.query), { external: true })
})
